import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

type Props = SvgIconProps;

const ForgotPasswordIcon: React.FC<Props> = (props) => {
  return (
    <SvgIcon viewBox="0 0 60 76" {...props}>
      <path
        d="M54.0016 35.3335H6.00159C3.80159 35.3335 2.00159 37.1335 2.00159 39.3335C2.00159 41.5335 3.80159 43.3335 6.00159 43.3335H6.66825V50.0002C6.66825 62.8668 17.1349 73.3335 30.0016 73.3335C42.8683 73.3335 53.3349 62.8668 53.3349 50.0002V43.3335H54.0016C56.2016 43.3335 58.0016 41.5335 58.0016 39.3335C58.0016 37.1335 56.2016 35.3335 54.0016 35.3335Z"
        fill={colors.light}
      />
      <path
        d="M60 39.3333C60 36 57.3333 33.3333 54 33.3333H48.6667V18.6667C48.6667 8.4 40.2667 0 30 0C19.7333 0 11.3333 8.4 11.3333 18.6667V33.3333H6C2.66667 33.3333 0 36 0 39.3333C0 42.6667 2.66667 45.3333 6 45.3333C7.13333 45.3333 8 44.4667 8 43.3333C8 42.2 7.13333 41.3333 6 41.3333C4.86667 41.3333 4 40.4667 4 39.3333C4 38.2 4.86667 37.3333 6 37.3333H54C55.1333 37.3333 56 38.2 56 39.3333C56 40.4667 55.1333 41.3333 54 41.3333H16C14.8667 41.3333 14 42.2 14 43.3333C14 44.4667 14.8667 45.3333 16 45.3333H51.3333V50C51.3333 61.7333 41.7333 71.3333 30 71.3333C18.2667 71.3333 8.66667 61.7333 8.66667 50C8.66667 48.8667 7.8 48 6.66667 48C5.53333 48 4.66667 48.8667 4.66667 50C4.66667 64 16 75.3333 30 75.3333C44 75.3333 55.3333 64 55.3333 50V45.2C58 44.6 60 42.2 60 39.3333ZM15.3333 18.6667C15.3333 10.6 21.9333 4 30 4C38.0667 4 44.6667 10.6 44.6667 18.6667V33.3333H15.3333V18.6667Z"
        fill="#444B54"
      />
      <path
        d="M30.0007 63.3332C28.8674 63.3332 28.0007 62.4665 28.0007 61.3332V56.6665C28.0007 55.5332 28.8674 54.6665 30.0007 54.6665C31.1341 54.6665 32.0007 55.5332 32.0007 56.6665V61.3332C32.0007 62.4665 31.1341 63.3332 30.0007 63.3332Z"
        fill="#FF8200"
      />
    </SvgIcon>
  );
};

export default ForgotPasswordIcon;
